import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/interlude',
            name: 'interlude',
            component: () => import("./views/interlude.vue"),
            meta: {
            }
        },
    ];
};